var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_196_1028)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13.1991C5 9.2574 5.44836 9.5325 7.86178 7.387C8.91769 6.5722 10.5607 5 11.9796 5C13.3977 5 15.0735 6.5645 16.139 7.387C18.5524 9.5325 19 9.2574 19 13.1991C19 19 17.5695 19 12 19C6.43052 19 5 19 5 13.1991Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87695 14.8948H14.1232",
    stroke: "url(#paint1_linear_196_1028)",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_1028",
    x1: 10.0909,
    y1: 0.00000418761,
    x2: 30.7951,
    y2: 5.95949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4462EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3DD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_196_1028",
    x1: 11.6623,
    y1: 14.8948,
    x2: 13.2529,
    y2: 16.8388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4462EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3DD8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedHome);
export default __webpack_public_path__ + "static/media/selected-home.ce2a71b3fc933829db9552ea5402fd30.svg";
export { ForwardRef as ReactComponent };